import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MobileBottomNav from './MobileBottomNav';
import AnnouncementBanner from '@/components/AnnouncementBanner';

export default function MainLayout() {
  const { pathname } = useLocation();
  const hideFooter = pathname.startsWith('/messages');

  return (
    <div className="min-h-screen flex flex-col">
      <AnnouncementBanner />
      <Header />
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
      <MobileBottomNav />
    </div>
  );
}
